export const ROLE_PATH = {
    user: "/user",
    admin: "/admin",
    superAdmin: "/superAdmin",
    recruiter: "/recruiter",
    employee: "/employee",
    employeeNotAllowed: "/employee_not_allowed",
    hiringManager: '/hiringManager',
    reviewer: '/reviewer',
}

export const ROLE = {
    superAdmin: "superAdmin",
    admin: "admin",
    user: "user",
    recruiter: "recruiter",
    hiringManager: "hiringManager",
    employee: "employee",
    reviewer: "reviewer",
}

